const OfflinePage = () => {
    return (
        <div>
            <h1>Offline Page</h1>
        </div>
    );
}
export default OfflinePage;
